
import { Component, Emit, Vue } from "vue-property-decorator";

@Component
export default class AppraiserValuationHeader extends Vue {
  @Emit("back") back() {}
  @Emit("update") update() {}
}
